import React, { useCallback, useRef, useState } from "react";
import { connect } from "react-redux";
import "../../../../../om/css/salesorder.css";
import { GridLayout } from "../../../../../common/GridLayout";
import { LoadPanel } from "devextreme-react/load-panel";
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Selection,
    Toolbar,
    Item,
    Export,
    Pager,
    ColumnChooser,
    ColumnChooserSearch,
    StateStoring,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../../../gridLayoutCustomization/GridLayoutManager";

const LocationResult = (props) => {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    const allowedPageSizes = [10, 20, 100, 500, 1000, "all"];
    const gridKey = "c4f9a7e1-3b2d-4a6c-9e8f-5d0a1b2c3456";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);

    return (
        <div style={{ height: '100%' }} id="locationResultContainer">
            <LoadPanel
                visible={props.loading === true}
                shading={true}
                shadingColor="rgba(0,0,0,0.08)"
                showIndicator={true}
                showPane={true}
                message="Loading..."
                position={{ my: "center", at: "center", of: "#locationResultContainer" }}
            />
            <DataGrid
                onExporting={(e) => {
                    if (window.handleDevExtremeDataGridExport) {
                        window.handleDevExtremeDataGridExport(e);
                    }
                }}
                ref={dataGrid}
                height="100%"
                dataSource={props.data}
                keyExpr="RLocation"
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className="SearchOrderSalesResultOpenState"
                searchEnabled={false}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <Export enabled={true} allowExportSelectedData={true} />
                <Selection mode="single" />
                <Sorting visible={true} mode="multiple" />
                <Paging defaultPageSize={10} />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={allowedPageSizes}
                    showNavigationButtons={true}
                />
                <FilterRow visible={false} />
                <FilterPanel visible={false} />
                <GroupPanel visible={false} />
                <Grouping autoExpandAll={false} />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Column dataField="LocationCode" caption="Location" />
                <Column dataField="warehouse" caption="Warehouse" />
                <Column dataField="Description" caption="Description" />
                <Column dataField="classcode" caption="Class" />
                <Column dataField="Subclasscode" caption="Sub Class" />
                <Column dataField="OnHand" caption="On Hand" />
                <Column dataField="Available" caption="Available" />
                <Column dataField="Netavailable" caption="Net Available" />
                <Column dataField="Priority" caption="Priority" visible={false} />
                <Column dataField="InOrdered" caption="In Ordered" visible={false} />
                <Column dataField="OutOrdered" caption="Out Ordered" visible={false} />
                <Column dataField="InReceiving" caption="In Receiving" visible={false} />
                <Column dataField="OutShipped" caption="Out Shipped" visible={false} />
                <Column dataField="InBackorder" caption="In Backorder" visible={false} />
                <Column dataField="OutBackorder" caption="Out Backorder" visible={false} />
                <Column dataField="InUnavailable" caption="In Unavailable" visible={false} />
                <Column dataField="OutUnavailable" caption="Out Unavailable" visible={false} />
                <Column dataField="InFuture" caption="In Future" visible={false} />
                <Column dataField="OutFuture" caption="Out Future" visible={false} />
                <Column dataField="Height" caption="Height" visible={false} />
                <Column dataField="Width" caption="Width" visible={false} />
                <Column dataField="Depth" caption="Depth" visible={false} />
                <Column dataField="Capacityarea" caption="Capacity Area" visible={false} />
                <Column dataField="Capacityvolume" caption="Capacity Volume" visible={false} />
                <Column dataField="Capacityunits" caption="Capacity Units" visible={false} />
                <Column dataField="Capacitypieces" caption="Capacity Pieces" visible={false} />
                <Column dataField="Capacityshippingunits" caption="Capacity Shipping Units" visible={false} />
                <Column dataField="Capacitycontainerunits" caption="Capacity Container Units" visible={false} />
                <Column dataField="Capacitygrossweight" caption="Capacity Gross Weight" visible={false} />
                <Column dataField="Capacitynetweight" caption="Capacity Net Weight" visible={false} />
                <Toolbar>
                    <Item location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </Item>
                    <Item name="exportButton" />
                    <Item name="columnChooserButton" />
                </Toolbar>
            </DataGrid>
        </div>
    );
};
function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(LocationResult);
